/* main.js — shared utilities, modal/toast plumbing, view switching, and boot:
   read settings → render cached dashboard immediately → sync in the background. */
(function () {
  'use strict';
  const CAD = (window.CAD = window.CAD || {});

  // ---------- inline icon set (lucide-style, 24x24 stroke) ----------

  const ICONS = {
    'user': '<path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>',
    'users': '<path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>',
    'scale': '<path d="m16 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z"/><path d="m2 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z"/><path d="M7 21h10"/><path d="M12 3v18"/><path d="M3 7h2c2 0 5-1 7-2 2 1 5 2 7 2h2"/>',
    'shield': '<path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1 1 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/>',
    'briefcase': '<path d="M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/><rect width="20" height="14" x="2" y="6" rx="2"/>',
    'dollar-sign': '<line x1="12" x2="12" y1="2" y2="22"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>',
    'code': '<polyline points="16 18 22 12 16 6"/><polyline points="8 6 2 12 8 18"/>',
    'file-question': '<path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"/><polyline points="14 2 14 8 20 8"/><path d="M9.9 16.5a2.5 2.5 0 1 1 3.8 2.1c-.6.4-1.2 1-1.2 1.8v.3"/><path d="M12.5 22h.01"/>',
    'file-text': '<path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"/><polyline points="14 2 14 8 20 8"/><line x1="16" x2="8" y1="13" y2="13"/><line x1="16" x2="8" y1="17" y2="17"/>',
    'settings': '<path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"/><circle cx="12" cy="12" r="3"/>',
    'refresh-cw': '<path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"/><path d="M21 3v5h-5"/><path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"/><path d="M8 16H3v5"/>',
    'x': '<path d="M18 6 6 18"/><path d="m6 6 12 12"/>',
    'download': '<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" x2="12" y1="15" y2="3"/>',
    'upload': '<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" x2="12" y1="3" y2="15"/>',
    'copy': '<rect width="14" height="14" x="8" y="8" rx="2"/><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"/>',
    'chevron-left': '<polyline points="15 18 9 12 15 6"/>',
    'chevron-right': '<polyline points="9 18 15 12 9 6"/>',
    'more-horizontal': '<circle cx="12" cy="12" r="1"/><circle cx="19" cy="12" r="1"/><circle cx="5" cy="12" r="1"/>',
    'maximize': '<polyline points="15 3 21 3 21 9"/><polyline points="9 21 3 21 3 15"/><line x1="21" x2="14" y1="3" y2="10"/><line x1="3" x2="10" y1="21" y2="14"/>',
    'bar-chart': '<path d="M3 3v18h18"/><path d="M18 17V9"/><path d="M13 17V5"/><path d="M8 17v-3"/>',
    'sparkles': '<path d="m12 3-1.9 5.8a2 2 0 0 1-1.3 1.3L3 12l5.8 1.9a2 2 0 0 1 1.3 1.3L12 21l1.9-5.8a2 2 0 0 1 1.3-1.3L21 12l-5.8-1.9a2 2 0 0 1-1.3-1.3Z"/>',
    'alert-triangle': '<path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"/><path d="M12 9v4"/><path d="M12 17h.01"/>',
    'check': '<polyline points="20 6 9 17 4 12"/>',
    'info': '<circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/>',
    'key-round': '<path d="M2 18v3c0 .6.4 1 1 1h4v-3h3v-3h2l1.4-1.4a6.5 6.5 0 1 0-4-4Z"/><circle cx="16.5" cy="7.5" r=".5" fill="currentColor"/>',
    'calendar': '<rect width="18" height="18" x="3" y="4" rx="2"/><line x1="16" x2="16" y1="2" y2="6"/><line x1="8" x2="8" y1="2" y2="6"/><line x1="3" x2="21" y1="10" y2="10"/>',
    'filter': '<polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/>',
    'trash-2': '<path d="M3 6h18"/><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/><line x1="10" x2="10" y1="11" y2="17"/><line x1="14" x2="14" y1="11" y2="17"/>',
    'clock': '<circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>',
    'eye': '<path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"/><circle cx="12" cy="12" r="3"/>',
    'eye-off': '<path d="M9.88 9.88a3 3 0 1 0 4.24 4.24"/><path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68"/><path d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61"/><line x1="2" x2="22" y1="2" y2="22"/>',
  };

  // ---------- utils ----------

  CAD.util = {
    icon: function (name, size) {
      const paths = ICONS[name] || ICONS['file-text'];
      const s = size || 18;
      return '<svg class="icon" width="' + s + '" height="' + s + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + paths + '</svg>';
    },
    escapeHtml: function (s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    },
    fmtNumber: function (n) { return (typeof n === 'number' ? n : 0).toLocaleString(); },
    fmtBytes: function (n) {
      if (n == null || isNaN(n)) return '\u2014';
      if (n < 1024) return n + ' B';
      const units = ['KB', 'MB', 'GB', 'TB'];
      let v = n;
      for (let i = 0; i < units.length; i++) {
        v = v / 1024;
        if (v < 1024 || i === units.length - 1) return (v >= 100 ? v.toFixed(0) : v.toFixed(1)) + ' ' + units[i];
      }
      return n + ' B';
    },
    fmtDateTime: function (iso) {
      const d = new Date(iso);
      if (isNaN(d.getTime())) return String(iso || '\u2014');
      return d.toLocaleString(undefined, { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
    },
    hexToRgba: function (hex, a) {
      let h = String(hex || '#94A3B8').replace('#', '');
      if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
      const n = parseInt(h, 16);
      return 'rgba(' + ((n >> 16) & 255) + ',' + ((n >> 8) & 255) + ',' + (n & 255) + ',' + a + ')';
    },
    darken: function (hex, f) {
      let h = String(hex || '#475569').replace('#', '');
      if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
      const n = parseInt(h, 16);
      const r = Math.round(((n >> 16) & 255) * (1 - f));
      const g = Math.round(((n >> 8) & 255) * (1 - f));
      const b = Math.round((n & 255) * (1 - f));
      return 'rgb(' + r + ',' + g + ',' + b + ')';
    },
    toast: function (msg, kind) {
      const root = document.getElementById('toast-root');
      if (!root) return;
      const el = document.createElement('div');
      el.className = 'toast' + (kind ? ' ' + kind : '');
      el.setAttribute('role', 'status');
      el.innerHTML = (kind === 'err' ? this.icon('alert-triangle') : this.icon('info')) + '<span>' + this.escapeHtml(msg) + '</span>';
      root.appendChild(el);
      const kill = function () { el.classList.add('leaving'); setTimeout(function () { el.remove(); }, 250); };
      el.addEventListener('click', kill);
      setTimeout(kill, 4200);
    },
    copyText: function (text) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        return navigator.clipboard.writeText(text).catch(function () { return legacyCopy(text); });
      }
      return Promise.resolve(legacyCopy(text));
      function legacyCopy(t) {
        const ta = document.createElement('textarea');
        ta.value = t;
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); } catch (err) { /* best effort */ }
        ta.remove();
      }
    },
    downloadText: function (filename, text, mime) {
      const blob = new Blob([text], { type: (mime || 'text/plain') + ';charset=utf-8' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(function () { URL.revokeObjectURL(url); }, 5000);
    },
  };

  // ---------- modal plumbing ----------

  CAD.ui = {
    modal: function (opts) {
      const root = document.getElementById('overlay-root');
      const wrap = document.createElement('div');
      wrap.className = 'overlay' + (opts.className ? ' ' + opts.className : '');
      wrap.innerHTML =
        '<div class="overlay-backdrop" data-close></div>' +
        '<div class="overlay-panel" role="dialog" aria-modal="true" aria-label="' + CAD.util.escapeHtml(opts.title || 'Dialog') + '">' +
        '  <header class="overlay-head"><h2>' + CAD.util.escapeHtml(opts.title || '') + '</h2>' +
        '    <button class="icon-btn overlay-close" type="button" aria-label="Close">' + CAD.util.icon('x') + '</button>' +
        '  </header>' +
        '  <div class="overlay-body">' + (opts.content || '') + '</div>' +
        '</div>';

      let closed = false;
      const opener = document.activeElement;
      const handle = {
        el: wrap,
        close: function () {
          if (closed) return;
          closed = true;
          document.removeEventListener('keydown', onKey);
          wrap.remove();
          if (opener && opener.focus) try { opener.focus(); } catch (err) { /* detached */ }
          if (opts.onClose) opts.onClose();
        },
      };

      function onKey(ev) {
        if (ev.key === 'Escape') {
          // Let the topmost overlay win: only close if this is the last one.
          const overlays = root.querySelectorAll('.overlay');
          if (overlays[overlays.length - 1] === wrap) handle.close();
        }
      }

      wrap.querySelector('.overlay-close').addEventListener('click', handle.close);
      wrap.querySelector('.overlay-backdrop').addEventListener('click', function () { handle.close(); });
      document.addEventListener('keydown', onKey);

      root.appendChild(wrap);
      const focusable = wrap.querySelector('.overlay-body button, .overlay-body input, .overlay-body select, .overlay-body textarea, .overlay-close');
      if (focusable) focusable.focus();
      else wrap.querySelector('.overlay-close').focus();

      if (opts.onOpen) opts.onOpen(handle);
      return handle;
    },
  };

  // ---------- app shell ----------

  let autoTimer = null;

  CAD.app = {
    showView: function (name) {
      const dash = document.getElementById('view-dashboard');
      const sett = document.getElementById('view-settings');
      const isDash = name === 'dashboard';
      dash.classList.toggle('hidden', !isDash);
      sett.classList.toggle('hidden', isDash);
      document.getElementById('nav-dashboard').classList.toggle('active', isDash);
      document.getElementById('nav-settings').classList.toggle('active', !isDash);
      if (isDash) CAD.dashboard.render(dash);
      else CAD.settings.render(sett);
      this.updateHeaderStatus();
    },
    refresh: function () {
      const dashVisible = !document.getElementById('view-dashboard').classList.contains('hidden');
      if (dashVisible) CAD.dashboard.render(document.getElementById('view-dashboard'));
      else CAD.settings.refreshSyncPanel();
      this.updateHeaderStatus();
    },
    resetDashboardState: function () {
      const s = CAD.dashboard.state;
      s.rangeMode = '30';
      s.customStart = null;
      s.customEnd = null;
      s.sliderStop = 3;
      s.w1Mode = 'list';
      s.bannerDismissed = false;
    },
    updateHeaderStatus: function () {
      const el = document.getElementById('header-sync-status');
      const btn = document.getElementById('header-sync-now');
      if (!el) return;
      const meta = CAD.storage.getSyncMeta();
      const running = meta.lastSyncStatus === 'running';
      btn.disabled = running;
      btn.classList.toggle('syncing', running);
      if (running) {
        el.innerHTML = '<span class="sync-dot running"></span>Syncing\u2026';
      } else if (meta.lastSyncStatus === 'error') {
        el.innerHTML = '<span class="sync-dot error"></span>Last sync failed';
      } else if (meta.lastSyncCompletedAt) {
        el.title = 'Last sync completed ' + CAD.util.fmtDateTime(meta.lastSyncCompletedAt);
        el.innerHTML = '<span class="sync-dot success"></span>Last synced ' + CAD.util.fmtDateTime(meta.lastSyncCompletedAt);
      } else {
        el.innerHTML = '<span class="sync-dot idle"></span>Never synced';
      }
    },
    armAutoSync: function () {
      if (autoTimer) { clearInterval(autoTimer); autoTimer = null; }
      const min = parseInt(CAD.storage.getSettings().autoSyncMinutes, 10) || 0;
      if (min > 0) autoTimer = setInterval(function () { CAD.sync.runSync(); }, min * 60000);
    },
  };

  // ---------- boot ----------

  async function boot() {
    await CAD.storage.ensureClassification();

    document.getElementById('nav-dashboard').addEventListener('click', function () { CAD.app.showView('dashboard'); });
    document.getElementById('nav-settings').addEventListener('click', function () { CAD.app.showView('settings'); });
    document.getElementById('header-sync-now').addEventListener('click', function () {
      CAD.sync.runSync({ manual: true });
      CAD.app.updateHeaderStatus();
    });

    document.addEventListener('cad:sync-start', function () {
      CAD.app.updateHeaderStatus();
      if (!document.getElementById('view-settings').classList.contains('hidden')) CAD.settings.refreshSyncPanel();
    });
    document.addEventListener('cad:sync-complete', function (ev) {
      CAD.app.refresh();
      if (ev.detail && ev.detail.manual) CAD.util.toast('Sync complete \u2014 ' + CAD.util.fmtNumber(CAD.storage.getSyncMeta().totalFilesStored) + ' files stored.');
    });
    document.addEventListener('cad:sync-error', function (ev) {
      CAD.app.refresh();
      const msg = ev.detail && ev.detail.error ? CAD.api.describeError(ev.detail.error) : 'Unknown error';
      if (ev.detail && ev.detail.manual) CAD.util.toast('Sync failed: ' + msg, 'err');
    });

    CAD.app.showView('dashboard');
    CAD.app.updateHeaderStatus();
    CAD.app.armAutoSync();

    // Render immediately from cache, then sync in the background — the user
    // should never stare at a blank screen waiting on the network.
    if (await CAD.api.hasCredential()) CAD.sync.runSync();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
